export const contact = {
    usersHead: 'Users',
    search: 'Search for anything',
    editContactHead: 'Edit Contact',
    createContactHead: 'New Contact',
    usersFilter: {
        allUsers: 'All Users',
        owner: 'Owner',
        speKExeC: 'speK ExeC',
        spekwoManager: 'speKwo Manager',
        seniorEstimator: 'Senior Estimator',
        estimator: 'Estimator',
        solutionEstimate: 'Solution Estimate',
        pro: 'Pro',
    },
    usersTable: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        role: 'Role',
        edit: 'Edit',
        remove: 'Remove'
    },
    noUsers: 'No user found',
    deleteConfirm: 'Are you sure you want to remove this user ?',
    deleteHead: 'Confirm',
    deleteOk: 'Yes',
    deleteCancel: 'Cancel',
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/contact.ts